export default {
	formatNumber: function (value) {
		if (!value) return 0;

		if (typeof value === 'string') {
			value = value.replace(/[^0-9]/g, '');
		}

		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},
	numberDisplay: function (value) {
		return value.toLocaleString();
	}
}